<app-action-menu
  [isMatButtonIcon]="false"
  [item]="treeNode"
  [display]="(isCurrentUserProjectManager && isProjectNode) || !isProjectNode"
  [actions]="actions"
>
  <img src="/assets/icons/icon-more.svg" alt="{{ 'imgAlt.menuIcon' | translate }}" />
</app-action-menu>
